import { Unstable_Grid2 as Grid, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { renderFieldView } from "../fieldsViews/renderFieldView";
import { renderFieldInput } from "../fieldsInputs/renderFieldInput";
import { Groups as GroupsType, formatGroups } from "../../utils/formatGroups";
import { UseFormReturn } from "react-hook-form";
import { useContext } from "react";
import { RecordContext } from "../record/Record";
import { GroupsOptions } from "../../types/groups.types";
import { FieldExtraOption, FormatedField, FormatedFields } from "../../types/fields.types";
import { getFieldExtraOption } from "../../utils/getFieldExtraOption";
import { omit } from "lodash";
import { GroupsTitle } from "./GroupsTitle";
import { FieldName } from "./FieldName";

type GroupsProps = {
    item?: any;
    fields?: FormatedFields;
    entityForm?: UseFormReturn;
    type?: string;
    groupsOptions?: GroupsOptions;
    bottomPadding?: number;
};

export function Groups({ item, fields, entityForm, type = "detail", groupsOptions, bottomPadding = 100 }: GroupsProps) {
    const context = useContext(RecordContext);

    if (!item && !fields && context) {
        item = context.item;
        fields = context.formatedFields;
    }

    if (!fields) return null;

    const { groups } = formatGroups(fields, item, type, groupsOptions?.fieldsWithExtraOptions);

    return (
        <Grid container justifyContent="flex-start" alignItems="top" display="flex" sx={{ backgroundColor: "#fff", paddingBottom: `${bottomPadding}px` }}>
            {groups?.map((group) => {
                if (group.hidden) return null;
                return (
                    <Grid key={group.groupId} p={4} xs={12} flex={1} lg={groupColumnSize(groups)} minWidth={300}>
                        <GroupsTitle title={group.groupName} />
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    {group?.fields.map((field) => {
                                        const extraOptions = groupsOptions?.fieldsWithExtraOptions;

                                        const fieldExtraOptions = extraOptions ? getFieldExtraOption(extraOptions, field) : null;

                                        const renderedField = renderFieldByType(type, field, item, entityForm, fieldExtraOptions);
                                        if (!renderedField) return null;
                                        return (
                                            <TableRow key={field.field}>
                                                <TableCell
                                                    sx={{
                                                        maxWidth: 400,
                                                        border: "0px",
                                                        paddingLeft: 0,
                                                        paddingTop: 2,
                                                    }}
                                                    align="left"
                                                >
                                                    {renderedField}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                );
            })}
        </Grid>
    );
}

const groupColumnSize = (groups: GroupsType) => {
    if (groups.length === 1) return 12;
    if (groups.length === 2) return 6;
    if (groups.length > 2) return 4;
};

const renderFieldByType = (
    type: string,
    field: FormatedField,
    item: any,
    entityForm: UseFormReturn | undefined,
    fieldExtraOptions: FieldExtraOption | null
) => {
    const isDirectusHidden = field.settings.hidden
    if (isDirectusHidden) return null;

    const isOptionsHiddenOn = fieldExtraOptions?.hidden;

    if (type === "detail") {
        if (isOptionsHiddenOn?.detail || isOptionsHiddenOn?.detailFn?.(item)) return null;
        return (
            <>
                <FieldName headerName={field.headerName} />
                {renderFieldView(field, item, "group", fieldExtraOptions)}
            </>
        );
    }

    if (type === "update") {
        if (isOptionsHiddenOn?.update || isOptionsHiddenOn?.updateFn?.(item)) return null;
        const updateExtraOptions = fieldExtraOptions ? omit(fieldExtraOptions, "defaultValue") : null;
        return entityForm && renderFieldInput(field, item, "group", entityForm, updateExtraOptions);
    }

    if (isOptionsHiddenOn?.create) return null;
    return entityForm && renderFieldInput(field, null, "group", entityForm, fieldExtraOptions);
};
